import React from 'react';
import { getProPrefixCls } from 'choerodon-ui/lib/configure';
import { BooleanValue, FieldType } from '../data-set/enum';
import Attachment from '../attachment/Attachment';
import { FuncType } from '../button/enum';
import { defaultRenderer } from '../field/utils';
export function defaultOutputRenderer(renderOption) {
    const { value, name, record } = renderOption;
    if (record) {
        const field = record.getField(name);
        if (field) {
            if (field.type === FieldType.boolean) {
                const checkBoxPrefix = getProPrefixCls('checkbox');
                return (React.createElement("label", { className: `${checkBoxPrefix}-wrapper ${checkBoxPrefix}-disabled` },
                    React.createElement("input", { disabled: true, className: checkBoxPrefix, type: "checkbox", checked: value === field.get(BooleanValue.trueValue) }),
                    React.createElement("i", { className: `${checkBoxPrefix}-inner` })));
            }
            if (field.type === FieldType.attachment) {
                return React.createElement(Attachment, { readOnly: true, name: name, viewMode: "popup", record: record, funcType: FuncType.link });
            }
        }
    }
    return defaultRenderer(renderOption);
}
